export const AlertType = {
    SUCCESS: "success",
    INFO: "info",
    ERROR: "error"
}